import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "current-directory row" }
const _hoisted_2 = { class: "row justify-between base-margin-bottom" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row no-wrap items-start" }
const _hoisted_5 = { class: "col-xs-12 base-margin-right" }

import { ref } from 'vue';
import { random } from 'SharedDir/utils/helpers';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'DocumentsSkeleton' },
  __name: 'DocumentsSkeleton',
  props: {
    compact: { type: Boolean, default: false }
  },
  setup(__props: any) {





const innerDocument = ref(random([1, 5]));

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'base-padding': !_ctx.compact }),
    style: _normalizeStyle(_ctx.compact ? undefined : { minHeight: '300px' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_skeleton, {
        class: "s-skeleton base-margin-right",
        width: `${_unref(random)([100, 140])}px`,
        style: {"max-width":"100%"},
        type: "rect",
        animation: "fade"
      }, null, 8, ["width"]),
      _createVNode(_component_q_skeleton, {
        class: "s-skeleton base-margin-right",
        width: `${_unref(random)([200, 240])}px`,
        style: {"max-width":"100%"},
        type: "rect",
        animation: "fade"
      }, null, 8, ["width"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_skeleton, {
          class: "s-skeleton base-margin-right",
          width: "40px",
          type: "QBtn",
          animation: "fade"
        }),
        _createVNode(_component_q_skeleton, {
          class: "s-skeleton base-margin-right",
          width: "40px",
          type: "QBtn",
          animation: "fade"
        }),
        _createVNode(_component_q_skeleton, {
          class: "s-skeleton base-margin-right",
          width: "40px",
          type: "QBtn",
          animation: "fade"
        }),
        _createVNode(_component_q_skeleton, {
          class: "s-skeleton base-margin-right",
          width: "40px",
          type: "QBtn",
          animation: "fade"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_q_skeleton, {
          class: "s-skeleton",
          width: "40px",
          type: "QBtn",
          animation: "fade"
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(innerDocument.value, (task, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "base-margin-bottom"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_skeleton, {
              class: "s-skeleton",
              height: "50px",
              style: {"max-width":"100%"},
              type: "rect",
              animation: "fade"
            })
          ])
        ])
      ]))
    }), 128))
  ], 6))
}
}

})